import React from 'react'
import styled from 'styled-components'
import Photo from '../Photo'
const FramedImg = styled.div`
    &.gray-bkg {
        background-color: #f4f4f4;
    }
    .framed-image-grid {
        display: grid;
        column-gap: 1rem;
        grid-template-columns: [spacer] 2fr [image] 8fr [spacer] 2fr;
    }
    .framed-image {
        grid-area: image;
    }
    img {
        width: 100%;
        max-width: auto;
    }
    @media all and (max-width: 767px) {
    .framed-image-grid {
        grid-template-columns: [spacer] 1fr [image] 10fr [spacer] 1fr;
    }
}
`
const FramedImage = ({altText, localFile, backgroundColor}) => {
    const bkg = backgroundColor === 'gray' ? true : false;
    return (
        <FramedImg className={bkg ? 'gray-bkg row-component' : 'row-component'}>
            <div className="contain">
                <div className="framed-image-grid">
                    <div className="framed-image">
                        <Photo altText={altText} localFile={localFile} />
                    </div>
                </div>
            </div>
        </FramedImg>
    )
}

export default FramedImage
